module.exports = __webpack_public_path__ + "static/media/elsa.30f268ad.png";